import apiFetch from '../apiFetch'

export default function () {
  return apiFetch({endPoint: `Analisis/getUltimoAnalisisExtraccion`, method: 'GET', body: null})
}
